<div class="cursor-pointer px-sm py-base min-w-[125px] md:min-w-max {{ containerClass }}">
  <div
    class="flex items-center text-base leading-base text-txt"
    [ngClass]="{
      'justify-end text-right': rightAlign,
      'pr-sm': rightAlign && sortable
    }"
    (click)="
      !onlySort
        ? sortMenuTrigger.openMenu()
        : emitSortChange({
            active: item.key,
            direction:
              !sortInfo || sortInfo.active !== item.key || !sortInfo.direction
                ? 'desc'
                : sortInfo.direction === 'desc'
                  ? 'asc'
                  : '',
            type: 'value'
          })
    "
  >
    <span [ngClass]="{ 'mr-sm': sortInfo && sortInfo.direction && sortInfo.active === item.key }">
      {{ item.label }}
    </span>
    @if (sortInfo && sortInfo.direction && sortInfo.active === item.key) {
      <div class="flex text-txt-secondary" [ngClass]="{ 'rotate-180': sortInfo.direction === 'asc' }">
        @if (sortInfo.direction) {
          <svg-icon key="arrow-up-full" class="!text-xs"></svg-icon>
        }
      </div>
    }
    @if (infoTitle) {
      <div
        [matTooltip]="infoTitle"
        [matTooltipPosition]="'above'"
        matTooltipClass="mg-tooltip-cell"
        class="hidden md:flex ml-[6px] text-primary"
      >
        <svg-icon key="info-circle" class="!text-xs"></svg-icon>
      </div>
    }
  </div>
  <div [matMenuTriggerFor]="sortMenu" #sortMenuTrigger="matMenuTrigger"></div>
</div>

<mat-menu
  #sortMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="mg-filter-menu"
>
  <div
    class="p-base flex flex-col gap-sm"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    <div class="flex items-center">
      <div class="flex-1 mr-base text-sm leading-sm">Value $</div>
      <div class="flex items-center">
        <div
          class="sort-btn mr-sm"
          [ngClass]="{
            'sort-btn-active':
              sortInfo &&
              sortInfo.active === item.key &&
              sortInfo.type === 'value' &&
              sortInfo.direction === 'asc'
          }"
          (click)="emitSortChange({ active: item.key, direction: 'asc', type: 'value' })"
        >
          Ascending
        </div>
        <div
          class="sort-btn"
          [ngClass]="{
            'sort-btn-active':
              sortInfo &&
              sortInfo.active === item.key &&
              sortInfo.type === 'value' &&
              sortInfo.direction === 'desc'
          }"
          (click)="emitSortChange({ active: item.key, direction: 'desc', type: 'value' })"
        >
          Descending
        </div>
      </div>
    </div>

    <div class="flex items-center">
      <div class="flex-1 mr-base text-sm leading-sm">Percentage</div>
      <div class="flex items-center">
        <div
          class="sort-btn mr-sm"
          [ngClass]="{
            'sort-btn-active':
              sortInfo &&
              sortInfo.active === item.key &&
              sortInfo.type === 'percentage' &&
              sortInfo.direction === 'asc'
          }"
          (click)="emitSortChange({ active: item.key, direction: 'asc', type: 'percentage' })"
        >
          Ascending
        </div>
        <div
          class="sort-btn"
          [ngClass]="{
            'sort-btn-active':
              sortInfo &&
              sortInfo.active === item.key &&
              sortInfo.type === 'percentage' &&
              sortInfo.direction === 'desc'
          }"
          (click)="emitSortChange({ active: item.key, direction: 'desc', type: 'percentage' })"
        >
          Descending
        </div>
      </div>
    </div>
  </div>
</mat-menu>
